import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

import dashboardAnalytics from '~/analytics/dashboard/dashboardAnalytics'
import oracleAnalytics from '~/analytics/oracle/oracleAnalytics'
import { OracleButtonClickTypes } from '~/analytics/oracle/oracleEvents.types'
import SearchAltIcon from '~/components/Icons/svgs/SearchAltIcon'
import ROUTES from '~/shared/constants/routes.const'
import { isAuthenticated } from '~/auth/slices/auth.slice'
import { selectIsChatAiOpen, setChatAiIsOpenActionCreator } from '~/redux/slices/chat-ai'
import { useAppDispatch, useAppSelector } from '~/redux/hooks'

// Keeps the search icon on purpose: Oracle links to content on the site, so it doubles as search
export const OracleButton = (): React.ReactElement => {
  const { t } = useTranslation('navbar')
  const router = useRouter()
  const dispatch = useAppDispatch()
  const authenticated = useAppSelector(isAuthenticated)
  const isChatAiOpen = useAppSelector(selectIsChatAiOpen)

  const handleClick = (): void => {
    dashboardAnalytics.handleHeaderTopMenuClick('oracle')

    // Unauthenticated users get the same treatment as the mobile bottom menu: send them to login first
    if (!authenticated) {
      router.push({ pathname: ROUTES.LOGIN, query: { from: router.asPath } })
      return
    }

    oracleAnalytics.logButtonClick(OracleButtonClickTypes.ORACLE_ICON)
    dispatch(setChatAiIsOpenActionCreator(!isChatAiOpen))
  }

  return (
    <button
      aria-label={t('search')}
      className="flex order-1 md:order-none w-9 h-9 items-center justify-center rounded-2.5 bg-white-dim"
      data-test-id="topbar-oracle"
      onClick={handleClick}
    >
      <SearchAltIcon className="w-6 h-6" pathClassName="text-white" />
    </button>
  )
}
